import React, { useState } from 'react';
import { Accordion } from '@cian/frontend-e2e-deal-component';

import { FAQAccordionContentLayout } from '../../components/FAQAccordionContentLayout';
import { FaqModalLayout } from '../../components/FaqModalLayout';
import { IFAQBlock, IFAQQuestion } from '../FAQSectionContainer';
import { useScrollToTopAnimation } from './utils/useScrollToTopAnimation';
import { trackFaqAccordionOpenClick } from './tracking';

export const FAQModalContainer: React.FC<IFAQBlock> = props => {
  const [openedAccordionIndex, setOpenedAccrdionIndex] = useState<number | null>(null);
  const onAccordionClick = (question: IFAQQuestion, clickedAccordionIndex: number) => () => {
    if (openedAccordionIndex === clickedAccordionIndex) {
      setOpenedAccrdionIndex(null);
    } else {
      trackFaqAccordionOpenClick(props.name, question.question);
      setOpenedAccrdionIndex(clickedAccordionIndex);
    }
  };

  const accordionRootRef = useScrollToTopAnimation(openedAccordionIndex);

  return (
    <FaqModalLayout ref={accordionRootRef}>
      {props.questions.map((question, i) => (
        <Accordion
          key={i}
          title={question.question}
          open={openedAccordionIndex === i}
          onClick={onAccordionClick(question, i)}
        >
          <FAQAccordionContentLayout>{question.answer}</FAQAccordionContentLayout>
        </Accordion>
      ))}
    </FaqModalLayout>
  );
};
